import { Card, CardContent } from "@/components/ui/card";
import { ProposalGallery } from "@/components/admin/estimates/ProposalGallery";
import { ProposalBeforeAfterGallery } from "@/components/admin/estimates/ProposalBeforeAfterGallery";

interface CustomerPhoto {
  id: string;
  url: string;
  caption?: string;
  display_order: number;
}

interface CustomerProposalGalleryProps {
  customerPhotos?: CustomerPhoto[];
  fallbackToGeneric?: boolean;
}

export function CustomerProposalGallery({
  customerPhotos,
  fallbackToGeneric = true,
}: CustomerProposalGalleryProps) {
  // If customer has photos, show them
  if (customerPhotos && customerPhotos.length > 0) {
    // Sort by display order
    const sortedPhotos = [...customerPhotos].sort((a, b) => a.display_order - b.display_order);
    
    return (
      <section className="my-12 page-break-before proposal-gallery">
        <div className="mb-8">
          <h2 className="text-3xl font-bold mb-2">Your Property</h2>
          <p className="text-muted-foreground">
            Photos of your roof taken during our inspection
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sortedPhotos.map((photo) => (
            <Card key={photo.id} className="overflow-hidden page-break-inside-avoid">
              <CardContent className="p-0">
                <div className="aspect-video relative">
                  <img
                    src={photo.url}
                    alt={photo.caption || "Roof photo"}
                    className="w-full h-full object-cover"
                  />
                </div>
                {photo.caption && (
                  <div className="p-4">
                    <p className="text-sm text-muted-foreground">{photo.caption}</p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    );
  }

  // Fallback to proposal-specific gallery if no customer photos
  if (fallbackToGeneric) {
    return (
      <>
        <section className="my-12 page-break-before proposal-gallery">
          <div className="mb-8">
            <h2 className="text-3xl font-bold mb-2">Our Recent Work</h2>
            <p className="text-muted-foreground">
              Examples of quality roofing projects we've completed
            </p>
          </div>
          <ProposalGallery />
        </section>

        <ProposalBeforeAfterGallery />
      </>
    );
  }

  return null;
}
